// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"80":"e0132f2c","176":"80823868","453":"798c042d","837":"e1f9b3f7","916":"d6d40aac"}[chunkId] + ".chunk.js");